// packages/viewport/src/store/actions.js
function setIsMatching(values) {
  return {
    type: "SET_IS_MATCHING",
    values
  };
}
export {
  setIsMatching
};
//# sourceMappingURL=actions.mjs.map
